// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut } from 'firebase/auth';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyANuGw0UUFVTOGzeTddyLyuI4ZBLNN8iyo",
    authDomain: "survey-creator-7d8a1.firebaseapp.com",
    projectId: "survey-creator-7d8a1",
    storageBucket: "survey-creator-7d8a1.firebasestorage.app",
    messagingSenderId: "982260291401",
    appId: "1:982260291401:web:edc5ec19c23080e301ec98",
    measurementId: "G-C4V0ZF3CQQ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();


export { auth, provider, signInWithPopup, signOut };